export class MenuFavoritoModel {
    favoriteId: string;
    role: string;
    label: string;
    route: string;
    icon?: string;
}
